import React, { forwardRef, Fragment, useState, useEffect } from "react";
import menu from "../menu";
import {
  AppBar,
  Button,
  Container,
  makeStyles,
  Toolbar,
  IconButton,
  Menu,
  Hidden,
  MenuItem,
  Drawer,
  ListItem,
  ListItemText,
  Typography,
  Badge,
  Card,
  CardContent,
} from "@material-ui/core";
import { backend } from "../../../api";
import DeleteIcon from "@material-ui/icons/Delete";
import { Search, Menu as MenuIcon, LocalMall } from "@material-ui/icons";
import { Link, NavLink, useHistory } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import SlideToggle from "react-slide-toggle";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../redux-store/auth/auth";
import { toast } from "react-toastify";
import placeHolder from "../../../images/placeholder.jpg";
import { useMyContext } from "../../../contextApi/context";
import CloseIcon from "@material-ui/icons/CloseOutlined";
import ChangePasswordModal from "../../../views/Dashboard/Customer/components/Modals/ChangePasswordModal";

const useStyles = makeStyles((theme) => ({
  mainHeader: {
    width: "100%",
    backgroundColor: "black",
    border: "none",
    boxShadow: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  header: {
    width: "70%",
  },
  logo: {
    marginTop : "5px",
    height: "60px",
  },
  topbarWrapper: {
    width: "100%",
  },
  headerContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0",
  },
  navbar: {
    display: "flex",
    justifyContent: "center",
  },
  navItem: {
    margin: "0 10px",
    color: theme.palette.primary.main,
    textTransform: "capitalize",
    fontSize: "15px",
    fontWeight: "200",
    letterSpacing: "1",
    textDecoration: "none",
  },
  activeNav: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  menuBtn: {
    color: "white",
  },
  iconBtn: {
    color: "white",
    margin: 0,
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
  mobileNav: {
    width: "100%",
    padding: "10px 0",
    backgroundColor: "black",
    borderTop: "1px solid white",
    borderBottom: "1px solid white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  mobileNavItem: {
    width: "100%",
    textAlign: "center",
    textDecoration: "none",
    color: "white",
    fontWeight: "200",
    margin: "10px 0",
  },
  activeMobileNav: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  cartIconWrapper: {
    flexDirection: "row",
    alignItems: "center",
  },
  drawerContent: {
    width: "100%",
    padding: theme.spacing(2),
    boxSizing: "border-box",
    overflowX: "hidden",
  },
  cartItemImage: {
    width: "80px",
    height: "80px",
    marginRight: theme.spacing(2),
    objectFit: "cover",
  },
  emptyCart: {
    padding: theme.spacing(2),
    textAlign: "center",
    width:"200px"
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
  },
  orderSummaryCard: {
    backgroundColor: "#f8f8f8",
    marginTop: theme.spacing(2),
  },
  closeIcon:{
    position:"absolute",
    top:theme.spacing(2.5),
    right:theme.spacing(1),
    color:"black"
  }
}));

const customRouterLink = forwardRef((props, ref) => (
  <div ref={ref}>
    <NavLink {...props} />
  </div>
));

function Topbar(props) {
  const classes = useStyles();
  const history = useHistory();
  const { cartItems, setCartItems, taxPercentage, book, setBook } = useMyContext();
  const { openSidebar } = props;
  const [anchorProfileMenu, setAnchorProfileMenu] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.auth);
  const [mblNavTgl, setMblNavTgl] = useState(0);
  const [isDisable,setIsDisable]=useState(false)
  const [deletingItemId, setDeletingItemId] = useState(null);
  const [passModal, setPassModal] = useState(false); // State for Change Password Modal

  useEffect(() => {
    backend
      .get("/shopCart")
      .then((response) => {
        setBook(response?.data);
        setCartItems(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const toggleMobileNav = () => {
    setMblNavTgl(mblNavTgl ? 0 : Date.now());
  };

  const handleProfileMenuOpen = (e) => {
    setAnchorProfileMenu(e.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorProfileMenu(null);
  };

  const handleDeleteCartItem = (itemId) => {
    if (!isDisable) {
      setIsDisable(true)
    
    backend
      .delete(`/shopCart/${itemId}`)
      .then(() => {
        setCartItems(cartItems.filter((item) => item._id !== itemId));
        toast.success("Item deleted from cart successfully");
      })
      .catch((error) => {
        toast.error("Failed to delete item from cart");
      }).finally(()=>{
        setIsDisable(false)
      });
    }
  };

  const handleLogOut = () => {
    dispatch(logout());
    localStorage.removeItem("Token");
    localStorage.removeItem("Role");
    history.push("/login");
  };

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const goToCart = () => {
    history.push("/shopping-cart");
    handleDrawerClose();
  };

  const trimTitle = (title, maxLength = 20) => {
    return title?.length <= maxLength ? title : `${title?.substring(0, maxLength)}...`;
  };

  const calculateItemPrice = (item) => {
    const bookOrderType = item?.bookOrderType;
    const quantity = item?.quantity || 1; // Assuming quantity defaults to 1 if not provided

    if (bookOrderType === "HARDCOPY") {
      return (item?.bookId?.price?.hardcover_price || 0) * quantity;
    } else if (bookOrderType === "BOTH") {
      return (
        (item?.bookId?.price?.hardcover_price || 0) * quantity +
        (item?.bookId?.price?.digital_price || 0)
      );
    } else if (item?.cartItemType === "ARTICLE") {
      return (
        (item?.articleId?.per_page_price || 0) *
        (item?.articleId?.number_of_pages || 0) *
        quantity
      );
    } else {
      return (item?.bookId?.price?.digital_price || 0) * quantity;
    }
  };

  const cartItemTotalPrices = cartItems.map((item) => calculateItemPrice(item));
  const totalPricessss = cartItemTotalPrices.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );

  const userRole = localStorage.getItem("Role");

  const handleOpenModal = () => {
    setPassModal(true);
    handleProfileMenuClose();
  };

  const handleCloseModal = () => {
    setPassModal(false);
  };
  const userId = currentUser?.author?.role === 'author' ? currentUser?.author?._id : currentUser?.user?._id;

  return (
    <Fragment>
      <AppBar className={classes.mainHeader}>
        <div className={classes.header}>
          <div className={classes.topbarWrapper}>
            <Container>
              <Toolbar className={classes.headerContainer}>
                <a
                  href="http://c5m.world.s3-website-us-east-1.amazonaws.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="../../../../assets/images/c5m-dark.png"
                    alt="Logo"
                    className={classes.logo}
                  />
                </a>
                <Hidden only={["lg", "xl"]}>
                  <IconButton className={classes.menuBtn} onClick={toggleMobileNav}>
                    <MenuIcon />
                  </IconButton>
                </Hidden>
                <Hidden only={["xs", "sm", "md"]}>
                  <div className={classes.navbar}>
                    {menu.map((item) => (
                      <NavLink
                        key={item.path}
                        className={classes.navItem}
                        to={item.path}
                        activeClassName={classes.activeNav}
                      >
                        {item.title}
                      </NavLink>
                    ))}
                  </div>
                </Hidden>
                <Menu
                  anchorEl={anchorProfileMenu}
                  keepMounted
                  open={Boolean(anchorProfileMenu)}
                  onClose={handleProfileMenuClose}
                >
                  <MenuItem onClick={handleProfileMenuClose}>
                    <Link
                      to={`/dashboard/${localStorage.getItem("Role")}`}
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      Dashboard
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={handleOpenModal}>Change Password</MenuItem>
                  <MenuItem onClick={handleLogOut}>Log Out</MenuItem>
                </Menu>
                {currentUser &&
                (currentUser.user ||
                  currentUser.author ||
                  currentUser.role === "member") ? (
                  <div className={classes.cartIconWrapper}>
                    <IconButton className={classes.iconBtn} onClick={handleProfileMenuOpen}>
                      <FaUserCircle />
                    </IconButton>
                    {userRole !== "author" && (
                      <IconButton className={classes.iconBtn} onClick={handleDrawerOpen}>
                        <Badge badgeContent={cartItems?.length} color="secondary">
                          <LocalMall />
                        </Badge>
                      </IconButton>
                    )}
                  </div>
                ) : (
                  <NavLink
                    className={classes.navItem}
                    activeClassName={classes.activeNav}
                    to="/login"
                  >
                    Login
                  </NavLink>
                )}
                <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose}>
                  <div className={classes.drawerContent}>
                  <IconButton className={classes.closeIcon} onClick={handleDrawerClose}>
                      <CloseIcon /> {/* 3. Add the close icon here */}
                    </IconButton>
                    {cartItems?.length > 0 ? (
                      <>
                        <h1
                          style={{
                            fontSize: "22px",
                            fontWeight: "bold",
                            margin: "8px",
                          }}
                        >{`Your Cart (${cartItems?.length})`}</h1>
                        {cartItems?.map((item) => (
                          <ListItem key={item._id} className={classes.cartItem} alignItems="flex-start">
                            <img
                              src={item.articleId?.article_image || item.bookId?.book_cover || placeHolder}
                              alt=""
                              className={classes.cartItemImage}
                            />
                            <ListItemText
                              primary={trimTitle(item.articleId?.article_title || item.bookId?.book_title)}
                              secondary={
                                <Typography component="span" variant="body2" color="textPrimary">
                                  Price: ${calculateItemPrice(item).toFixed(2)}
                                </Typography>
                              }
                            />
                            <IconButton
                              style={{ marginLeft: "22px" }}
                              edge="end"
                              aria-label="delete"
                              onClick={() => handleDeleteCartItem(item._id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </ListItem>
                        ))}
                        <Card style={{ backgroundColor: "#f8f8f8", marginTop: "20px" }}>
                          <CardContent>
                            <Typography variant="h6" gutterBottom>
                              Order Summary
                            </Typography>
                            <Typography variant="body1">
                              Total: ${totalPricessss.toFixed(2)}
                            </Typography>
                          </CardContent>
                        </Card>
                        <div className={classes.buttonContainer}>
                          <Button onClick={goToCart} variant="contained" color="primary">
                            View Cart
                          </Button>
                          <Button
                            onClick={() => {
                              history.push("/cart-checkout");
                              handleDrawerClose();
                            }}
                            variant="contained"
                            color="secondary"
                          >
                            Checkout
                          </Button>
                        </div>
                      </>
                    ) : (
                      <div className={classes.emptyCart}>Cart is empty</div>
                    )}
                  </div>
                </Drawer>
              </Toolbar>
            </Container>
          </div>
          <Hidden only={["lg", "xl"]}>
            {mblNavTgl !== 0 && (
              <SlideToggle
                duration={400}
                toggleEvent={mblNavTgl}
                render={({ setCollapsibleElement }) => (
                  <div className={classes.mobileNav} ref={setCollapsibleElement}>
                    {menu.map((item) => (
                      <NavLink
                        key={item.path}
                        className={classes.mobileNavItem}
                        to={item.path}
                        onClick={toggleMobileNav}
                        activeClassName={classes.activeMobileNav}
                      >
                        {item.title}
                      </NavLink>
                    ))}
                  </div>
                )}
              ></SlideToggle>
            )}
          </Hidden>
        </div>
      </AppBar>
      <ChangePasswordModal
        visible={passModal}
        closeModal={handleCloseModal}
        userId={userId}
      />
    </Fragment>
  );
}

export default Topbar;
